"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoresSchema = void 0;
const z = require("zod");
exports.ScoresSchema = z.custom((value) => typeof value === 'object' && value !== null, {
    message: 'overallScores must be an object',
});
//# sourceMappingURL=experiment-scores.js.map